import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import EtaHint from '../components/EtaHint';
import { pushToast } from '../hooks/useToasts';
/**
 * Decodificación distribuida POR NAVEGADORES: el servidor extrae los frames del
 * vídeo y crea una tarea de cómputo `qrdecode` que los navegadores de los
 * visitantes resuelven (con el contribuidor de cómputo); al completarse, el
 * servidor reconstruye el archivo. Se sigue en el panel (progreso = frames
 * decodificados por navegadores).
 */
export default function BrowserDecode() {
    const { t } = useTranslation();
    const nav = useNavigate();
    const [file, setFile] = useState(null);
    const [sampleGroup, setSampleGroup] = useState(1);
    const [expectSha256, setExpectSha256] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const onSubmit = async (e) => {
        e.preventDefault();
        if (!file)
            return;
        setBusy(true);
        setError(null);
        const fd = new FormData();
        fd.append('file', file);
        fd.append('params', JSON.stringify({ sampleGroup, expectSha256: expectSha256.trim() || null }));
        try {
            await api.post('/jobs/bdecode', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            pushToast({ kind: 'info', title: t('jobLaunched.title'), msg: t('jobLaunched.msg') });
            nav('/dashboard');
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("section", { className: "prose", children: [_jsx("h1", { children: t('bdecode.title') }), _jsx("p", { className: "muted", children: t('bdecode.intro') }), _jsxs("form", { onSubmit: onSubmit, className: "card form-card", children: [_jsxs("label", { children: [t('decode.videoLabel'), _jsx("input", { type: "file", accept: "video/*", required: true, onChange: (e) => setFile(e.target.files?.[0] ?? null) })] }), _jsxs("div", { className: "grid-2", children: [_jsxs("label", { children: [t('decode.sampleGroup'), _jsx("input", { type: "number", min: 1, max: 30, value: sampleGroup, onChange: (e) => setSampleGroup(Math.max(1, Number(e.target.value) || 1)) }), _jsx("small", { className: "muted", children: t('decode.sampleGroupHelp') })] }), _jsxs("label", { children: [t('orchestrate.expectSha256'), _jsx("input", { type: "text", placeholder: "64 hex", pattern: "[0-9a-fA-F]{64}", value: expectSha256, onChange: (e) => setExpectSha256(e.target.value) })] })] }), error && _jsx("p", { className: "error", children: error }), _jsx("p", { className: "muted", children: t('bdecode.note') }), _jsx(EtaHint, { kind: "bdecode" }), _jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy || !file, children: busy ? t('common.loading') : t('bdecode.submit') })] })] }));
}
